// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__W+85N","title":"styles_title__iBCLB","message":"styles_message__kO95k"};